export const FETCH_USER_TYPES = "FETCH_USER_TYPES";

export const INSERT_USER_TYPE = "INSERT_USER_TYPE";

export const DELETE_USER_TYPE = "DELETE_USER_TYPE";

export const EDIT_USER_TYPE_INFO = "EDIT_USER_TYPE_INFO";
